import { Nav } from "../components/site/Nav";
import { Hero } from "../components/site/Hero";
import { StatsMarquee } from "../components/site/StatsMarquee";
import { About } from "../components/site/About";
import { Services } from "../components/site/Services";
import { Capabilities } from "../components/site/Capabilities";
import { Industries } from "../components/site/Industries";
import { Manifesto } from "../components/site/Manifesto";
import { Experience } from "../components/site/Experience";
import { Founder } from "../components/site/Founder";
import { GlobalPresence } from "../components/site/GlobalPresence";
import { Contact } from "../components/site/Contact";
import { Footer } from "../components/site/Footer";

export default function Home() {
  return (
    <div className="relative">
      <Nav />
      <main>
        <Hero />
        <StatsMarquee />
        <About />
        <Services />
        <Capabilities />
        <Industries />
        <Manifesto />
        <Experience />
        <Founder />
        <GlobalPresence />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
